import { LinkPlugin as LexicalLinkPlugin } from '@lexical/react/LexicalLinkPlugin';
import { validateUrl } from '../../utils';

export const LinkPlugin = () => {
  return (
    <LexicalLinkPlugin
      validateUrl={validateUrl}
      attributes={{
        rel: 'noopener noreferrer',
        target: '_blank',
      }}
    />
  );
};
